import { useEffect, useState } from "react";

/**
 * @typedef {Record<string, any>} ActiveGenre
 */

/**
 * @typedef {(updater: ActiveGenre | ((prev: ActiveGenre) => ActiveGenre)) => void} SetActiveGenre
 */

/** @type {ActiveGenre} */
let activeGenre = {};

/** @type {Set<(state: ActiveGenre) => void>} */
const listeners = new Set();

/**
 * @returns {ActiveGenre}
 */
export const getActiveGenre = () => activeGenre;

/**
 * @type {SetActiveGenre}
 */
export const setActiveGenre = (updater) => {
  activeGenre = typeof updater === "function" ? updater(activeGenre) : updater;
  listeners.forEach((listener) => listener(activeGenre));
};

/**
 * @returns {[ActiveGenre, SetActiveGenre]}
 */
export const useActiveGenre = () => {
  const [state, setState] = useState(activeGenre);

  useEffect(() => {
    const listener = (newState) => setState(newState);
    listeners.add(listener);

    return () => listeners.delete(listener);
  }, []);

  return [state, setActiveGenre];
};
